import { useState } from "react";
import GridingCheckboxSingle from "./GridingCheckboxSingle";

export default function GridingCheckbox({ state, setState, givenOptions, maxFive = 999, maxFour = 999 }) {





    const formCheckboxJSX = Object.keys(state).map((single, index) => (<GridingCheckboxSingle givenOptions={givenOptions} maxFour={maxFour} maxFive={maxFive} index={index} key={index} single={single} state={state} handleState={setState} />));
    const handleAdd = () => {
        setState({
            ...state,
            "": {}
        })
    }
    return (
        <div>
            {formCheckboxJSX}

        </div>
    )
}